import { CreatedContractInterface } from '../../../core';

export class CreatedContract implements CreatedContractInterface {
    private readonly _success: boolean = undefined;
    private readonly _redirect: boolean = undefined;

    constructor(success, redirect) {
        this._success = success;
        this._redirect = redirect;
    }

    get success(): boolean {
        return this._success;
    }

    get redirect(): boolean {
        return this._redirect;
    }
}
